import { getCountry } from 'utils/utils';
const country = getCountry().toLowerCase();
const model = require(`./${country}`)?.default || {} ;
export default model;
